import getBrowserLogger from './get-browser-logger';

export type { Logger, LoggerOptions } from '@zg-rentals/logger-base';

export * from './get-browser-logger';
export * from './get-child-logger';
export * from './global';
export default getBrowserLogger;
